const CTOS_STATUSES = [
  { text: 'All', value: 'All' },
  { text: 'New', value: 'new' },
  { text: 'Pending', value: 'pending' },
  { text: 'Multiple Entity', value: 'multiple_entities' },
  { text: 'Success', value: 'success' },
  { text: 'Failed', value: 'failed' },
];
export default CTOS_STATUSES;



// WEBPACK FOOTER //
// ./src/constants/ctosStatus.js